import React, { createContext } from "react";

export const PlayerContext = createContext();

export function PlayerContextProvider(props) {
  const nowPlaying = {};

  return <PlayerContext.Provider value={{ nowPlaying }} {...props} />;
}
